var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCaretLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3595 25.5479C20.6863 25.9931 20.5904 26.619 20.1451 26.9458C19.6999 27.2726 19.0741 27.1766 18.7473 26.7314L11.2371 16.6021C10.9429 16.2013 10.8998 15.9457 11.2371 15.6021L18.7473 5.40832C19.0741 4.96311 19.6999 4.86713 20.1451 5.19395C20.5904 5.52076 20.6863 6.14661 20.3595 6.59182L13.402 16.0699L20.3595 25.5479Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCaretLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/caret-left.fad12eb12f8efd186c58889b186c7d9c.svg";